import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { auth } from '../../../services';

export const GET_PREFERENCE_REQUEST = 'GET_PREFERENCE_REQUEST';
export const GET_PREFERENCE_SUCCESS = 'GET_PREFERENCE_SUCCESS';
export const GET_PREFERENCE_ERROR = 'GET_PREFERENCE_ERROR';
export const UPDATE_PREFERENCE_REQUEST = 'UPDATE_PREFERENCE_REQUEST';
export const UPDATE_PREFERENCE_SUCCESS = 'UPDATE_PREFERENCE_SUCCESS';
export const UPDATE_PREFERENCE_ERROR = 'UPDATE_PREFERENCE_ERROR';

export const getPreference = (userId) => {
    return (dispatch) => {
        dispatch({
            type: GET_PREFERENCE_REQUEST,
            payload: userId
        });

        var url = `${ROOT_API_URL}/signup/preference/${userId}`;
        var options = {
            method: 'GET',
            headers: auth.authHeader()
        };

        axios.get(url, options).then((response) => {
            if (response && response.data){
                dispatch({
                    type: GET_PREFERENCE_SUCCESS,
                    payload: response.data || []
                });
            }else{
                dispatch({
                    type: GET_PREFERENCE_ERROR,
                    payload: "Error Occured"
                });
            }
        }).catch((res) => {
            dispatch({
                type: GET_PREFERENCE_ERROR,
                payload: "Error Occured"
            });
        });
    }
}

export const savePreference = (data, userId) => {
    return (dispatch) => {
        dispatch({
            type: UPDATE_PREFERENCE_REQUEST,
            payload: userId
        });
        var url = `${ROOT_API_URL}/signup/SavePreferences/${userId}`;
        const options = {
            method: 'POST',
            headers: auth.authHeader()
        };
        axios.post(url, data, options)
        .then((response) => {
            if (response && response.data){
                dispatch({
                    type: UPDATE_PREFERENCE_SUCCESS,
                    payload: data
                });
            }else{
                dispatch({
                    type: UPDATE_PREFERENCE_ERROR,
                    payload: "Error Occured"
                });
            }
        }).catch((res) => {
            dispatch({
                type: UPDATE_PREFERENCE_ERROR,
                payload: "Error Occured"
            });
        });
    }
}

